// extracted by mini-css-extract-plugin
export default {"wrapper":"AddStorie_wrapper__zkbaQ","main":"AddStorie_main__uH95R","main_add":"AddStorie_main_add__jJHYd","main_item":"AddStorie_main_item__vgsWX"};